import React from 'react'
import "./Fryrightfooter.css";
import { useNavigate } from 'react-router-dom';
// import footerimg from "../../../../assets/images/footerimg.webp"
const Fryrightfooter = () => {
  const navigate = useNavigate()
  return (
    <div className='fryrightfooter'>
        <div className='textarea'> 
            <h1>It's about knowing how to Fry Right!</h1>
            <p>Don’t wait to help make it easier for your employees to increase savings and sales!</p>
        </div>
        <div className='img'>
            <img src="https://all-frontend-assets.s3.amazonaws.com/fryright_images/footerimg.webp" alt="#" />
        </div>
        <div className='but'>
            <button  onClick={()=>navigate("/contact")}>Contact Us Today!</button>
        </div>
    </div>
  )
}

export default Fryrightfooter